/**
 * BBE Skio CPv3 — upsell save bar beneath thumbnails (cart-drawer parity).
 * Loaded on /a/account via theme.liquid.
 *
 * IMPORTANT: Do not reparent Skio nodes — wrapping image containers breaks React
 * Add handlers. Badge is appended inside the image container only.
 */
(function () {
  if (window.__bbeSkioUpsellBadgesBound) return;
  window.__bbeSkioUpsellBadgesBound = true;

  var SAVE_BADGE_MARK = 'data-bbe-skio-save-badge';
  var SAVE_PCT_LABEL = '10% OFF';
  var LEGACY_MEDIA_CLASS = 'bbe-skio-upsell-media';

  function parseMoney(el) {
    if (!el) return null;
    var n = parseFloat(String(el.textContent || '').replace(/[^0-9.]/g, ''));
    return isFinite(n) ? n : null;
  }

  function formatMoney(n) {
    return '$' + n.toFixed(2);
  }

  function getSkioRoot() {
    return document.getElementById('skio-root') || document.getElementById('skio-portal');
  }

  /** Undo legacy wrapper that broke Skio Add (Aug 2026). */
  function unwrapLegacyMediaWrappers(root) {
    var legacy = root.querySelectorAll('.' + LEGACY_MEDIA_CLASS);
    for (var i = 0; i < legacy.length; i++) {
      var wrap = legacy[i];
      var imgC = wrap.querySelector('[data-skio-name="upsell-product-image-container"]');
      if (imgC && wrap.parentNode) {
        wrap.parentNode.insertBefore(imgC, wrap);
        wrap.parentNode.removeChild(wrap);
      }
    }
  }

  function ensureUpsellSaveBadges() {
    var root = getSkioRoot();
    if (!root) return;

    unwrapLegacyMediaWrappers(root);

    var cards = root.querySelectorAll('[data-skio-name="upsell-product"]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var imgC = card.querySelector('[data-skio-name="upsell-product-image-container"]');
      if (!imgC) continue;

      var strike = parseMoney(
        card.querySelector('[data-skio-name="upsell-product-strikethrough-price"]')
      );
      var price = parseMoney(card.querySelector('[data-skio-name="product-price"]'));
      var save = strike != null && price != null ? strike - price : 0;
      var badge = imgC.querySelector('[' + SAVE_BADGE_MARK + ']');

      if (!(save > 0.004)) {
        if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
        imgC.classList.remove('bbe-skio-upsell-image--discounted');
        continue;
      }

      imgC.classList.add('bbe-skio-upsell-image--discounted');

      var label = SAVE_PCT_LABEL + ' - ' + formatMoney(save);
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'bbe-skio-upsell-save-badge';
        badge.setAttribute(SAVE_BADGE_MARK, '');
        imgC.appendChild(badge);
      }
      if (badge.textContent !== label) badge.textContent = label;
    }
  }

  function tick() {
    try {
      ensureUpsellSaveBadges();
    } catch (e) {}
  }

  tick();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  }
  setTimeout(tick, 400);
  setTimeout(tick, 1200);
  setTimeout(tick, 3000);

  var t = null;
  var mo = new MutationObserver(function () {
    if (t) clearTimeout(t);
    t = setTimeout(tick, 100);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
